module.exports = __webpack_public_path__ + "assets/no-reorders-7e4ca8.svg";